import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
const loader = new GLTFLoader();
const materials = {
  windowMaterial: new THREE.MeshStandardMaterial({
    color: "#ffffff",
    opacity: 1,
  }),
  wall: new THREE.MeshStandardMaterial({ color: "#e4e1df" }),
};

export class House extends THREE.Object3D {
  constructor(loop, x, z, y = 0) {
    super();

    this.name = "House";
    this.position.set(x, y, z);
    this.params = {
      x: x,
      y: y - 0.1,
      z: z,
      height: 1,
      scale: 0.16,
    };
    this.rotation.y = Math.random() * Math.PI * 2;
    this.hillHeightTarget = 0;
    this.hillHeightCurrent = 0;
    this.boxHelper = null;
    this.loadedMesh = null;

    this.lightIntensityTarget = 0;

    loop.updatables.push(this);
    this.lights = [];
    this.houseLoader(Math.floor(Math.random() * 4) + 1, this.params);
  }

  setHillHeight(height) {
    this.hillHeightTarget = height;
  }

  setLit(on) {
    this.lightIntensityTarget = on ? 3 : 0.1;
  }

  tick(delta) {
    this.hillHeightCurrent +=
      (this.hillHeightTarget - this.hillHeightCurrent) * 0.15;
    this.position.x = this.params.x;
    this.position.y =
      this.params.y + 0.5 + this.params.height / 2 + this.hillHeightCurrent;
    this.position.z = this.params.z;
    this.scale.y = this.params.height;

    if (this.lights != undefined) {
      for (const light of this.lights) {
        light.intensity += (this.lightIntensityTarget - light.intensity) * 0.12;
      }
    }

    if (this.boxHelper && this.loadedMesh) {
      this.boxHelper.update(this.loadedMesh);
    }
  }
  houseLoader(houseNum, params) {
    loader.load(`/blender/house${houseNum}.glb`, (gltf) => {
      const house = gltf.scene;
      house.scale.set(params.scale, params.scale, params.scale);
      house.traverse((elem) => {
        if (elem.isLight) {
          elem.intensity = 0;
          elem.color.set("#FFDF93");
          this.lights.push(elem);
        } else if (elem.isMesh) {
          elem.material = materials.wall.clone();
          elem.geometry.computeVertexNormals();
          elem.needsUpdate = true;
        }
      });
      centerToOrigin(house);

      this.loadedMesh = house;
      this.add(house);

      const boxHelper = new THREE.BoxHelper(house, 0xff0000);
      boxHelper.name = "HouseBounds";
      this.boxHelper = boxHelper;
      boxHelper.update(house);
      // this.add(boxHelper);
    });
  }
}

function addOutline(mesh, thickness = 0.03, color = 0x000000) {
  const outline = new THREE.Mesh(
    mesh.geometry.clone(),
    new THREE.MeshBasicMaterial({
      color,
      side: THREE.BackSide,
    })
  );

  outline.scale.multiplyScalar(1 + thickness);
  mesh.add(outline);
}

function centerToOrigin(object3d) {
  const box = new THREE.Box3().setFromObject(object3d);
  const center = new THREE.Vector3();
  box.getCenter(center);
  object3d.position.sub(center);
}
